<p-dialog
  modal="true"
  styleClass="atlas-dialog-l"
  position="top"
  [closable]="true" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4>{{ 'reports.NAHB-export.view-validation-issues.title' | translate | titlecase }}</h4>
  </ng-template>

  <a (click)="exportValidationIssues()">
    {{ 'reports.NAHB-export.view-validation-issues.export-validation-issue' | translate | titlecase }}
  </a>

  <p-table [showGridlines]="true" [value]="searchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 20" [lazy]="true" [totalRecords]="searchResult?.TotalCount" (onLazyLoad)="lazyLoad($event)">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="LineNumber" class="w-5">
          {{ 'reports.NAHB-export.view-validation-issues.line-number' | translate | titlecase }}
          <p-sortIcon field="LineNumber"></p-sortIcon>
        </th>
        <th pSortableColumn="ProfileId" class="w-5">
          {{ 'reports.NAHB-export.view-validation-issues.profile-id' | translate | titlecase }}
          <p-sortIcon field="ProfileId"></p-sortIcon>
        </th>
        <th pSortableColumn="ValidationIssue" class="w-20">
          {{ 'reports.NAHB-export.view-validation-issues.validation-issue' | translate | titlecase }}
          <p-sortIcon field="ValidationIssue"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-validationIssue>
      <tr>
        <td>{{ validationIssue.LineNumber }}</td>
        <td>{{ validationIssue.ProfileId }}</td>
        <td>{{ validationIssue.ValidationIssue }}</td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <wl-page-size-dropdown
    [(pageSize)]="searchParams.PageSize"
    [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"
  ></wl-page-size-dropdown>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
